import type { WorkflowOutputKind } from '@/services/data/CampaignService';

/**
 * Launch-facing order for the small-business / creator ICP. These workflows
 * make the product promise legible in a few seconds: turn existing inputs
 * into native content, launch a campaign, engage the audience, then learn
 * what to make next.
 */
export const FEATURED_WORKFLOW_NAMES = [
  'Long Video → Short-Form Posts',
  'Brand Site → Voice + Kit + 5 Starter Posts',
  'Product Launch Sequence (3-week)',
  'Article → Multi-Platform Pack',
  'Comment Reply Drafts',
  'Performance Loop → Next-Week Strategy',
] as const;

export function sortFeaturedWorkflows<T extends { name: string }>(templates: T[]): T[] {
  const featuredRank = new Map(FEATURED_WORKFLOW_NAMES.map((name, index) => [name, index]));
  return [...templates].sort(
    (a, b) =>
      (featuredRank.get(a.name) ?? FEATURED_WORKFLOW_NAMES.length) -
      (featuredRank.get(b.name) ?? FEATURED_WORKFLOW_NAMES.length),
  );
}

export const OUTPUT_KIND_LABEL: Record<WorkflowOutputKind, string> = {
  post: 'Posts',
  image: 'Images',
  video: 'Videos',
  carousel: 'Carousel',
  strategy: 'Strategy',
  document: 'Document',
  'brand-guidelines': 'Brand kit',
};

export const ALL_OUTPUT_KINDS: WorkflowOutputKind[] = [
  'post',
  'image',
  'video',
  'carousel',
  'strategy',
  'document',
];

export function formatEstimate(min?: number | null, max?: number | null): string | null {
  if (min == null && max == null) return null;
  if (min != null && max != null) {
    if (min === max) return `${min} min`;
    return `${min}–${max} min`;
  }
  return `${min ?? max} min`;
}
